<div class="alert-container main-font align-items-center">
  <i class="icons info fill-svg-blue-800"></i>
  <div class="text-message" [innerHTML]="message"></div>
</div>
